'use client';

import { useEffect } from 'react';

import { useStore } from '@/entities/store';
import { SignIn } from '@/features/auth/sign-in/ui';
import { Layout } from '@/widgets/layout/ui';

const LoginPage = () => {
  const { user } = useStore();

  useEffect(() => {
    if (user.isAuthorized) {
      user.logout();
    }
  }, [user]);

  return (
    <Layout>
      <SignIn />
    </Layout>

  );
};

export default LoginPage;
